import Forbidden from '../components/error-pages/forbidden';
import PageNotFound from '../components/error-pages/page-not-found';
import Demo from '../pages/demo';
import ErrorPage from '../pages/error';

export default [
  {
    path: '/demo',
    name: 'demo',
    component: Demo,
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorPage,
    children: [
      {
        path: '403',
        name: 'error-403',
        component: Forbidden,
        meta: { noLayoutRequired: true },
      },
      {
        path: '404',
        name: 'error-404',
        component: PageNotFound,
        meta: { noLayoutRequired: true },
      },
    ],
  },
];
